module.exports = __webpack_public_path__ + "static/3-bc3a4e6ceb68e36f67f4978079ef0aa9.jpg";